/* scarlett-pdp-loupe.js — floating magnifier ("loupe") for the PDP hero.
   Desktop + fine pointer only: hover the image to inspect detail in a lens that
   follows the cursor, sampling the highest-resolution source available (so it
   shows real detail, capped by the source — never promises blur). Click still
   opens Dawn's full-screen lightbox; touch devices skip the loupe and just tap
   to open the lightbox. Pure progressive enhancement, scoped to .scH-pdp. */
(function () {
  if (!window.matchMedia || !matchMedia('(any-hover: hover) and (any-pointer: fine)').matches) return;
  var ZOOM = 2.1, LENS = 240;
  var lens = null, img = null, raf = 0;

  function makeLens() {
    if (lens) return lens;
    lens = document.createElement('div');
    lens.className = 'scH-loupe';
    lens.setAttribute('aria-hidden', 'true');
    lens.style.display = 'none';
    document.body.appendChild(lens);
    return lens;
  }
  function hiRes(im) {
    var ss = im.getAttribute('srcset'), best = im.currentSrc || im.src, bw = 0;
    if (ss) ss.split(',').forEach(function (p) {
      var m = p.trim().match(/(\S+)\s+(\d+)w/);
      if (m && +m[2] > bw) { bw = +m[2]; best = m[1]; }
    });
    return best;
  }
  function show(im) {
    if (!im || !im.naturalWidth || im.naturalWidth < 400) return; // too small to inspect
    img = im;
    makeLens();
    lens.style.width = lens.style.height = LENS + 'px';
    lens.style.backgroundImage = "url('" + hiRes(im) + "')";
    lens.style.display = 'block';
  }
  function move(e) {
    if (!img || !lens || lens.style.display === 'none') return;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var r = img.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) { hide(); return; }
      lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
      lens.style.backgroundPosition = (-(x * ZOOM - LENS / 2)) + 'px ' + (-(y * ZOOM - LENS / 2)) + 'px';
      lens.style.left = (e.clientX - LENS / 2) + 'px';
      lens.style.top = (e.clientY - LENS / 2) + 'px';
    });
  }
  function hide() { if (lens) lens.style.display = 'none'; img = null; }

  function bind(opener) {
    if (opener.__loupe) return;
    opener.__loupe = true;
    // Bind on the modal-opener, NOT .product__media: Dawn's full-area .product__media-toggle
    // button sits ON TOP as a SIBLING of .product__media, so a real hover never reaches
    // .product__media. The modal-opener is the ancestor of both, so it does receive the hover.
    opener.addEventListener('mouseenter', function () { show(opener.querySelector('img')); });
    opener.addEventListener('mousemove', move);
    opener.addEventListener('mouseleave', hide);
    opener.addEventListener('mousedown', hide); // a click opens the lightbox — drop the lens
  }
  function init() {
    var root = document.querySelector('.scH-pdp');
    if (!root) return;
    function all() { root.querySelectorAll('.product__media-item .product__modal-opener').forEach(bind); }
    all();
    if ('MutationObserver' in window) new MutationObserver(all).observe(root, { subtree: true, childList: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
